import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { AccessPermissionAddUserCatracaRequest } from 'src/app/models/dtos/access-controller/accessPermissionAddUserCatracaRequest';
import { AccessPoint } from 'src/app/models/dtos/access-controller/accessPoint';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AccessPointService {
  env:string = environment.apiHost + '/api-core/secure/access-point/';
  constructor(private http: HttpClient) {}


  getAllByMarina(): Observable<AccessPoint[]> {
    return this.http
      .get(this.env + 'list-all')
      .pipe(map((response: any) => response as AccessPoint[]));
  }

  getAllByMarinaAndActive(active:boolean): Observable<AccessPoint[]> {
    return this.http
      .get(this.env + 'list-all/' + active)
      .pipe(map((response: any) => response as AccessPoint[]));
  }

  save(accessPoint: AccessPoint): Observable<AccessPoint> {
    return this.http
      .post(this.env + 'save', accessPoint)
      .pipe(map((response: any) => response as AccessPoint));
  }

  delete(id: number): Observable<void> {
    return this.http
      .delete(this.env + 'delete/' + id)
      .pipe(map((response: any) => response as void));
  }

  ingetracaoCatraca(request:AccessPermissionAddUserCatracaRequest):Observable<boolean>{
    return this.http
      .post( environment.apiHost + '/api-core/secure/access-permission/add-user-catraca', request)
      .pipe(map((response: any) => response as boolean));
  }

  removerCatraca(request:AccessPermissionAddUserCatracaRequest):Observable<boolean>{
    return this.http
      .post( environment.apiHost + '/api-core/secure/access-permission/remove-user-catraca', request)
      .pipe(map((response: any) => response as boolean));
  }

  checkKeepAlive(id: number): Observable<boolean> {
    return this.http
      .get(this.env + 'check-keep-alive/' + id)
      .pipe(map((response: any) => response as boolean));
  }

  align(id: number): Observable<void> {
    return this.http
      .get(this.env + 'align/' + id)
      .pipe(map((response: any) => response as void));
  }
}
